"use client";
import { create } from "zustand";

interface ProtocolStore {
  bambuAIAccept: string;
  bambuTechAIAccept: string;
  showAIProtocolModal: (payload: string) => void;
  showTechAIProtocolModal: (payload: string) => void;
}

export const useProtocolStore = create<ProtocolStore>((set) => ({
  bambuAIAccept: "",
  bambuTechAIAccept: "",

  showAIProtocolModal: (payload) => {
    set({ bambuAIAccept: payload });
  },

  showTechAIProtocolModal: (payload) => {
    set({ bambuTechAIAccept: payload });
  },
}));
